import { HttpClient, HttpMethods } from "@planzone/services";

function getDocumentTemplatesFolder(httpClient: HttpClient) {
  return (planzone: string) =>
    httpClient.sendHttpRequest<any>({
      endpoint: `/api/folder/planzone/${planzone}/documentTemplate`,
      method: HttpMethods.POST,
    });
}

export { getDocumentTemplatesFolder };
